<template>
	<div class="styleLoaders"></div>
</template>

<script>
	export default {
		name: 'styleLoaders',
		data () {
			return {
				videos: [

				]
			}
		},
		beforeDestroy: function(){
			if((this.$root)&&(this.$root.closeMenu)){
				this.$root.closeMenu()
			}
		}
	}
</script>
<style language="less">
@font-face {
  font-family: 'gdr-icons';
  src:  url('/static/css/fonts/gdr-icons.eot');
  src:  url('/static/css/fonts/gdr-icons.eot#iefix') format('embedded-opentype'),
    url('/static/css/fonts/gdr-icons.ttf') format('truetype'),
    url('/static/css/fonts/gdr-icons.woff') format('woff'),
    url('/static/css/fonts/gdr-icons.svg') format('svg');
  font-weight: normal;
  font-style: normal;
}

.gdr-icon {
  /* use !important to prevent issues with browser extensions that change fonts */
  font-family: 'gdr-icons' !important;
  speak: none;
  font-style: normal;
  font-weight: normal;
  font-variant: normal;
  text-transform: none;
  line-height: 1;

  /* Better Font Rendering =========== */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.gdr-icon-check:before {
  content: "\f00c";
}
.gdr-icon-close:before {
  content: "\f00d";
}
.gdr-icon-remove:before {
  content: "\f00d";
}
.gdr-icon-times:before {
  content: "\f00d";
}
.gdr-icon-arrow-circle-o-up:before {
  content: "\f01b";
}
.gdr-icon-pencil:before {
  content: "\f040";
}
.gdr-icon-question-circle:before {
  content: "\f059";
}
.gdr-icon-info-circle:before {
  content: "\f05a";
}
.gdr-icon-exclamation-triangle:before {
  content: "\f071";
}
.gdr-icon-warning:before {
  content: "\f071";
}
.gdr-icon-twitter:before {
  content: "\f099";
}
.gdr-icon-facebook:before {
  content: "\f09a";
}
.gdr-icon-facebook-f:before {
  content: "\f09a";
}
.gdr-icon-bars:before {
  content: "\f0c9";
}
.gdr-icon-navicon:before {
  content: "\f0c9";
}
.gdr-icon-reorder:before {
  content: "\f0c9";
}
.gdr-icon-google-plus:before {
  content: "\f0d5";
}
.gdr-icon-html5:before {
  content: "\f13b";
}
.gdr-icon-css3:before {
  content: "\f13c";
}
.gdr-icon-thumbs-up:before {
  content: "\f164";
}
.gdr-icon-thumbs-down:before {
  content: "\f165";
}
.gdr-icon-youtube:before {
  content: "\f167";
}
.gdr-icon-youtube-play:before {
  content: "\f16a";
}
.gdr-icon-android:before {
  content: "\f17b";
}
.gdr-icon-chrome:before {
  content: "\f268";
}
.gdr-icon-firefox:before {
  content: "\f269";
}
.gdr-icon-opera:before {
  content: "\f26a";
}
.gdr-icon-edge:before {
  content: "\f282";
}
.gdr-icon-gitlab:before {
  content: "\f296";
}
.gdr-icon-android-2:before {
  content: "\e900";
  color: #a4c639;
}
.gdr-icon-csslogo:before {
  content: "\e901";
  color: #f43059;
}
.gdr-icon-jslogo:before {
  content: "\e902";
  color: #f7df1e;
}
.gdr-icon-vue:before {
  content: "\e903";
  color: #4fc08d;
}
</style>


// WEBPACK FOOTER //
// styleLoaders.vue?4b6a63e9